import {
  BellOutlined,
  CheckSquareOutlined,
  FolderOpenOutlined,
  HomeOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';
import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { useNotificationUnreadCount } from '@/hooks/useNotificationUnreadCount';

export type MobileTabKey =
  | 'leader-home'
  | 'leader-projects'
  | 'leader-team'
  | 'leader-notifications'
  | 'leader-mine'
  | 'employee-home'
  | 'employee-tasks'
  | 'employee-notifications'
  | 'employee-mine';

interface TabItem {
  key: MobileTabKey;
  to: string;
  label: string;
  icon: ReactNode;
  badgeKey?: 'notifications';
}

const LEADER_TABS: TabItem[] = [
  { key: 'leader-home', to: ROUTES.mobile.leader.home, label: '首页', icon: <HomeOutlined className="mobile-tab-bar__icon" /> },
  { key: 'leader-projects', to: ROUTES.mobile.leader.projects, label: '项目', icon: <FolderOpenOutlined className="mobile-tab-bar__icon" /> },
  { key: 'leader-team', to: ROUTES.mobile.leader.team, label: '团队', icon: <TeamOutlined className="mobile-tab-bar__icon" /> },
  {
    key: 'leader-notifications',
    to: ROUTES.mobile.leader.notifications,
    label: '消息',
    icon: <BellOutlined className="mobile-tab-bar__icon" />,
    badgeKey: 'notifications',
  },
  { key: 'leader-mine', to: ROUTES.mobile.leader.mine, label: '我的', icon: <UserOutlined className="mobile-tab-bar__icon" /> },
];

const EMPLOYEE_TABS: TabItem[] = [
  { key: 'employee-home', to: ROUTES.mobile.employee.home, label: '首页', icon: <HomeOutlined className="mobile-tab-bar__icon" /> },
  {
    key: 'employee-tasks',
    to: ROUTES.mobile.employee.tasks,
    label: '任务',
    icon: <CheckSquareOutlined className="mobile-tab-bar__icon" />,
  },
  {
    key: 'employee-notifications',
    to: ROUTES.mobile.employee.notifications,
    label: '消息',
    icon: <BellOutlined className="mobile-tab-bar__icon" />,
    badgeKey: 'notifications',
  },
  { key: 'employee-mine', to: ROUTES.mobile.employee.mine, label: '我的', icon: <UserOutlined className="mobile-tab-bar__icon" /> },
];

interface MobileTabBarProps {
  variant: 'leader' | 'employee';
}

export function MobileTabBar({ variant }: MobileTabBarProps) {
  const tabs = variant === 'leader' ? LEADER_TABS : EMPLOYEE_TABS;
  const { count: unreadCount } = useNotificationUnreadCount();

  return (
    <nav className="mobile-tab-bar" aria-label="底部导航">
      {tabs.map((tab) => (
        <NavLink
          key={tab.key}
          to={tab.to}
          className={({ isActive }) =>
            `mobile-tab-bar__item${isActive ? ' mobile-tab-bar__item--active' : ''}`
          }
          end
        >
          <span className="mobile-tab-bar__icon-wrap">
            {tab.icon}
            {tab.badgeKey === 'notifications' && unreadCount > 0 ? (
              <span className="mobile-tab-bar__badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
            ) : null}
          </span>
          <span>{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
